import React from 'react';
import { toast } from 'react-toastify';

export default function AvailableVariables() {
  const data = [{ name: 'user name i.e zvr_name', value: '{{name}}' },
  { name: 'Gift Card Coupon code', value: '{{code}}' },
  { name: 'Message or Call sender id i.e s_mobile_no', value: '{{sender_id}}' },
  { name: 'User\'s Doosra number', value: '{{number_d}}' },
  { name: 'Gift Card Coupon code', value: '{{code}}' },
  { name: 'User name', value: '{{zvr_name}}' },
  { name: 'OTP for login / signup', value: '{{otp}}' },
  { name: 'N.A.', value: '{{message}}' },
  { name: 'user account url(Not sure about it find it from profile)', value: '{{url}}' },
  { name: 'user account expiry date', value: '{{date}}' },
  { name: 'user account termination date', value: '{{termination_date}}' },
  { name: 'user account plan type', value: '{{plan_type}}' },
  { name: 'credit / debit card last 4 digits', value: '{{card_last4}}' },
  { name: 'user name i.e zvr_name', value: '{{name}}' },
  { name: 'next plan type for free trial users', value: '{{free_trial_next_plan}}' },
  { name: 'next amount to be charged after free trial', value: '{{free_trial_next_amount}}' },
  // { name: 'business organisation name', value: '{{biz_org}}' },
  { name: 'days left to user expiry', value: '{{days_left}}' },
  ];

  const copyItem = (value) => {
    navigator.clipboard.writeText(value);
    toast.success('Copied to clipboard')
  }


  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignContent: 'center', alignItems: 'center', marginTop: '40px' }}>
      <h2>Variable Codes</h2>
      <table>
        <tr>
          <th style={{ textAlign: 'left' }}>Varaiable Name</th>
          <th>Variable Code</th>

        </tr>
        {
          data.map(item => (
            <tr>
              <td style={{ textAlign: 'left' }}>{item.name}</td>
              <td onClick={() => copyItem(item.item)} style={{ cursor: 'pointer' }}>{item.value}</td>

            </tr>
          ))
        }
      </table>
    </div>
  )
}